
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import TextBox from './../../zviz2/zviz/components/textbox';
import Link from './../../zviz2/zviz/components/link';
import FilterBlueprint from './filter';
import {extend, cloneObject} from './../../zviz2/zviz/functions';
import {styleWords} from './../../styles';
import config from './../../config';
//import {LifeCycle} from './../zviz2/zviz/cycle';

class Controller extends GroupController{

    constructor(parent, blueprint={}){
        super(parent, blueprint);
    }

    getChildren(){

        // not sure if this is the best place for this...
        if(state.get('source') != 'planned'){
            state.set('filter.planned_completion_date', null);
        }

        let result = [];
        let filters = state.get('filter');
        if(filters){
            if(state.get('renderSize') == 'small'){
                result.push(cloneObject(BlueprintReset));
            }
            for(let filter of Object.keys(filters)){
                result.push(extend({
                    uid: '_hF'+filter,
                    properties: { 
                        data: {
                            name: filter,
                            value: filters[filter],
                            isFixed: state.get('source') == 'planned' &&
                                    ['eval_rpt_end_year', 'planned_flag'].includes(filter)
                        }
                    }
                }, FilterBlueprint));            
            }
            if(state.get('renderSize') != 'small' && state.get('source') != 'planned'){
                result.push(cloneObject(BlueprintReset));
            }
        }else{
            return [cloneObject(BlueprintNoFilters)];
        }
        
        return result;
    }


}



let Blueprint = {
    type: Controller,
     listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'filter') ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'source') )
    ],
    properties: {
        style: {
            margin: '0px auto',
            maxWidth: '1138px',
            padding: (ctrl) => ( (state.get('renderSize') == 'small')? '0px 5px': 
                    ( (state.get('renderSize') == 'medium')? '0px 15px 0px 20px': '0px 20px 0px 20px') )
        }
    },
    events: {  },
    children: [
        extend({
            properties: {
                style: extend({
                        lineHeight: '30px',
                        paddingRight: '10px',
                        verticalAlign: 'middle'
                    }, styleWords),
                content: 'Filters'
            }
        }, TextBox),

        (ctrl) => ( ctrl.getChildren() )
    ]
};


let BlueprintNoFilters = extend({
    properties: {
        style: extend({
                lineHeight: '30px',
                paddingRight: '15px',
                fontStyle: 'italic'
            }, styleWords),
        content: 'No active filters'
    }
}, TextBox);

let BlueprintReset = extend({
    properties: {
        style: extend({
            display: 'block',
            float: 'right',
            height: (ctrl) => ( (state.get('renderSize') == 'small')? '24px': '28px'),
            lineHeight: (ctrl) => ( (state.get('renderSize') == 'small')? '24px': '28px'),
            fontSize: '10pt',
            marginTop: (ctrl) => ( (state.get('renderSize') == 'small')? '5px': '10px'),
            color: 'white',
            padding: '0px 12px 0px 30px',
            backgroundColor: (ctrl) => ( ctrl.data.isHover? '#FB636F': '#FA3C4B' ),
            backgroundImage: 'url(\'' + config.imgPath + 'reset.png\')',
            backgroundPosition: '5px center',
            backgroundRepeat: 'no-repeat'
        }, styleWords),
        data: { isHover: false },
        content: 'Reset'
    },
    events: {
        click: (event, ctrl) => { state.set('filter', null); },
        mouseover: (event, ctrl) => { ctrl.data.isHover = true; ctrl.update(); },   // this does no longer work
        mouseout: (event, ctrl) => { ctrl.data.isHover = false; ctrl.update(); }
    }
}, Link)


export default Blueprint;
export {Controller, Blueprint};
